import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { daysFromNow } from '@zapier/date';

import { useIsAuthenticated } from '@zapier/design-system-revenue/src/hooks';

import { shouldRenderCompanyTrialEndedBanner as ShouldRenderCompanyTrialEndedBannerQuery } from './types/shouldRenderCompanyTrialEndedBanner';

export const shouldRenderCompanyTrialEndedBannerQuery = gql`
  query shouldRenderCompanyTrialEndedBanner($accountId: Int!) {
    account(id: $accountId) {
      id
      isCompanyAccount
      companiesTrialEndDate
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useShouldRender = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();

  const accountId = localStorage.getItem('currentAccountId');

  const { data } = useQuery<ShouldRenderCompanyTrialEndedBannerQuery>(
    shouldRenderCompanyTrialEndedBannerQuery,
    {
      skip: skip || !isAuthenticated || !accountId,
      variables: {
        accountId: parseInt(accountId ?? ''),
      },
    }
  );

  return (
    !data?.account?.isCompanyAccount &&
    !!data?.account?.companiesTrialEndDate &&
    daysFromNow(data?.account?.companiesTrialEndDate) <= 7
  );
};
